module.exports = __webpack_public_path__ + "static/media/SlackClone.d12540ea.png";